<template>
  <div>
    <section class="pricing-table">
      <div class="container">
        <div class="block-heading">
          <h2 data-test="vendorPlan2Head1"
														id="vendorPlan2Head1">
											Pricing Template</h2>
        </div>
        <div class="row justify-content-md-center">
          <div
            class="col-md-5"
            v-for="(plan,index) in planData"
            :class="(planData.length === 4)?'col-lg-3':
                       (planData.length === 3)?'col-lg-4':
                       (planData.length <= 2)?'col-lg-6':'col-lg-2'"
            :key="index"
          >
            <div class="item">
              <div class="heading">
                <h3 data-test="vendorPlan2Name"
																				id="vendorPlan2Name">{{plan.name.toUpperCase()}}</h3>
              </div>
              <p>{{plan.description}}</p>
              <div class="features">
                <h4 data-test="vendorPlan2PeriodHead"
																				id="vendorPlan2PeriodHead">
                  <span class="feature"
																								data-test="vendorPlan2PeriodSpan"
																								id="vendorPlan2PeriodSpan">Period</span>
                  :
                  <span class="value"
																								data-test="vendorPlan2Period"
																								id="vendorPlan2Period">{{plan.period}}</span>
                </h4>
                <h4 data-test="vendorPlan2IntervalHead"
																				id="vendorPlan2IntervalHead">
                  <span class="feature"
																								data-test="vendorPlan2IntervalSpan"
																								id="vendorPlan2IntervalSpan">Interval</span>
                  :
                  <span class="value"
																								data-test="vendorPlan2Interval"
																								id="vendorPlan2Interval">{{plan.interval}}</span>
                </h4>
                <h4 data-test="vendorPlan2MaxHead"
																				id="vendorPlan2MaxHead">
                  <span class="feature"
																								data-test="vendorPlan2MaxSpan"
																								id="vendorPlan2MaxSpan">Max Orders</span>
                  :
                  <span class="value"
																								data-test="vendorPlan2Max"
																								id="vendorPlan2Max">{{plan.max_order_quantity}}</span>
                </h4>
                <h4 data-test="vendorPlan2MaxProHead"
																				id="vendorPlan2MaxProHead">
                  <span class="feature"
																								data-test="vendorPlan2MaxProSpan"
																								id="vendorPlan2MaxProSpan">Max Products</span>
                  :
                  <span class="value"
																								data-test="vendorPlan2MaxPro"
																								id="vendorPlan2MaxPro">{{plan.max_product_quantity}}</span>
                </h4>
              </div>
              <div class="price">
                <h4
																	data-test="vendorPlan2Amt"
																	id="vendorPlan2Amt">{{plan.amount | currencyConversion}}</h4>
              </div>
              <!--<button-->
              <!--class="btn btn-block btn-outline-primary"-->
              <!--type="submit"-->
              <!--@click.prevent="planSelect(plan, index)"-->
              <!--v-if="!payNow || !(choosedIndex ===index)"-->
              <!--v-scroll-to="{-->
              <!--el: '#plan-confirm-date-picker',-->
              <!--offset: 200-->
              <!--}"-->
              <!--&gt;-->
              <button
                class="btn btn-block btn-outline-primary"
                type="submit"
                @click.prevent="planSelect(plan, index)"
                v-if="!payNow || !(choosedIndex ===index)"
																data-test="vendorPlan2BuyNowBtn"
																id="vendorPlan2BuyNowBtn"
              >
                BUY NOW
              </button>
              <razor-pay-web
                :subscriptionId="subscriptionId"
                v-if="payNow && (choosedIndex ===index)"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="compare">
      <div class="container">
        <h2 class="p-4"
												data-test="vendorPlan2Head2"
												id="vendorPlan2Head2">Compare</h2>
        <ul
          class="vendor-plan-mobile-switcher list-unstyled"
          v-if="screenWidth < 992"
        >
          <li
            class="switcher"
            v-for="(plan, index) in planData"
            :key="index"
            @click.prevent="selectedPlanIndex = index"
            :class="isActive[index] === true?'active':''"
          >
            <a
              type="button"
              class="btn btn-primary btn-type-primary"
														data-test="vendorPlan2NameLink"
														id="vendorPlan2NameLink"
            >
              {{plan.name.toUpperCase()}}
            </a>
          </li>
        </ul>
        <div class="row">
          <div class="col-lg-12">
            <div class="table-responsve">
              <table class="table table-striped table-hover">
                <!--<thead class="thead-inverse">-->
                <!--<tr>-->

                <!--<th class="" v-if="!show">-->
                <!--{{planData[selectedPlanIndex].name.toUpperCase()}}-->
                <!--</th>-->

                <!--</tr>-->
                <!--</thead>-->
                <tbody>
                  <tr v-if="show">
                    <th class="w-25"></th>
                    <th
                      v-for="(plan, index) in planData"
                      :key="index"
																						:data-test="'vendorPlan2PlanNameHead'+index"
																						:id="'vendorPlan2PlanNameHead'+index"
                    >
                      {{plan.name.toUpperCase()}}
                    </th>
                  </tr>
                  <tr
                    v-for="(plan,key,index) in planData[0]"
                    :key="key"
                  >
                    <td v-if="!(index === 0 || index === 1)"
																								:data-test="'vendorPlan2PlanKeyHead'+index"
																								:id="'vendorPlan2PlanKeyHead'+index">
                      {{key.toUpperCase().replace(/_/g, ' ')}}
                    </td>
                    <td
                      v-for="(plan, index) in ((!(key === 'plan_id' ||
                      key === 'payment_gateway_plan_id') && show) ? planData : []) "
                      :key="index"
                      :class="'pid-'+index"
																						:data-test="'vendorPlan2KeyHead'+index"
																						:id="'vendorPlan2KeyHead'+index"
                    >
                      {{plan[key]}}
                    </td>
                    <td v-if="!(key === 'plan_id' ||
                      key === 'payment_gateway_plan_id') && !show"
																								:data-test="'vendorPlan2PlanData'+index"
																								:id="'vendorPlan2PlanData'+index">
                      {{planData[selectedPlanIndex][key]}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { vendorApis } from '@/services/ApiServices/vendorApis'
// import DatePicker from 'vue2-datepicker';
// import razorPayWeb from '@/components/pages/paymentGateway/razorPay/RazorPayWebIntegrationSubscription'
import razorPayWeb from '@/components/pages/paymentGateway/razorPay/RazorPayWebIntegration'
import { mapGetters } from 'vuex'

export default {
	name: 'test2',
	components: {
		// DatePicker,
		razorPayWeb
	},
	data () {
		return {
			screenWidth: screen.width,
			payNow: false,
			selectedPlanIndex: 0,
			value4: '',
			planData: [],
			selectedPlan: {},
			subscriptionId: '',
			choosedIndex: -1,
			isActive: [],
			show: false
		}
	},
	computed: {
		...mapGetters('vendor', ['getStatusData'])
	},
	mounted () {
		vendorApis.vendorInfo().then(() => {
			if (this.getVendorData && this.getVendorData.payment_status) {
				this.$router.push('/pages/vendordashboard')
			}
		})
		this.screenWidth = screen.width
		this.getVendorPlans()
		// this.$nextTick(() => {
		// $(".pid-0").addClass('shown');
		//   });
		this.show = screen.width >= 992
	},
	methods: {
		initjq () {
			$('.pid-0').addClass('shown')
		},
		mobileselect (e) {
			// let pid = e.data('target');
			//
			// document.querySelectorAll(pid);
			$(document).on('click', '[data-toggle="planselect"]', function () {
				const $target = $($(this).data('target'))
				// $target.toggleClass(classes);

				for (let i = 0; i < $target.length; i++) {
					$($target[i]).addClass('shown')
				}
			})
		},
		planSelect (plan, index) {
			this.choosedIndex = index
			this.payNow = true
			this.selectedPlan = plan
			this.planSubmit()
		},
		planClassActiveDeactive () {
			this.planData.forEach((plan, index) => {
				if (this.selectedPlanIndex !== index) {
					this.isActive[index] = false
				} else {
					this.isActive[index] = true
				}
			})
		},
		getVendorPlans () {
			vendorApis.getVendorPlan().then((res) => {
				this.planData = res.data
				this.planClassActiveDeactive()

				setTimeout(() => {
					this.initjq()
				}, 1000)
			})
		},
		planSubmit () {
			vendorApis.subscriptionCreate(this.selectedPlan.plan_id).then((res) => {

			})
			// vendorApis.subscriptionPlan(this.selectedPlan.plan_id).then((res) => {
			// 	this.subscriptionId = res.data.subscription_id
			// })
		}
	},
	watch: {
		selectedPlanIndex () {
			this.planClassActiveDeactive()
		}
	},
	beforeRouteEnter (to, from, next) {
		// if () {
		//
		// }
		next()
	}
}
</script>
